import Vue from 'vue';
import Component from 'vue-class-component';
import REQ_URL from "@/consts/req-url";
import Worker from "worker-loader!@/workers/download.worker";
import storageObservable from '@/api/storageObservable';
import { TaskStatus, Task, DownloadGlobalState } from '@/types/downloadManager';

let worker: Worker | null;

@Component({
})
export default class DownloadManager extends Vue {
    status: TaskStatus = 'not installed'
    isDownloadAll = false
    dialog = false
    msg = ''
    error = ''

    headers = [
        {
            text: 'База данных',
            sortable: false
        },
        {
            text: 'Статус',
            sortable: false,
            align: 'center'
        },
        {
            text: '',
            sortable: false
        }
    ]
    tasks: Task[] = []
    get autoDownload() {
        return this.$store.state.network.autoDownload
    }
    set autoDownload(val: boolean) {
        this.$store.dispatch('setAutoDownload', val)
    }
    get state() {
        return this.tasks.reduce((acc, task) => {
            return {
                page: acc.page + task.page,
                total: acc.total + task.total
            }
        }, {
                page: 0,
                total: 0,
            })
    }
    get needUpdate() {
        return this.tasks.length ? this.tasks.reduce((accumulator, task) => {
            return accumulator && task.needUpdate
        }, true) : false
    }
    get needUpdateCalc() {
        return this.needUpdate && (this.status === 'installed' || this.status === 'not installed')
    }
    get totalProgress() {
        return this.calcProgress(this.state.page, this.state.total)
    }
    get textStatus() {
        switch (this.status) {
            case 'downloading':
                return {
                    text: 'Идёт загрузка',
                    color: 'light-blue--text text--darken-4'
                }
            case 'completed':
                let completedNow = this.tasks.reduce((acc, task) => {
                    return acc || task.needUpdate || task.page !== 0
                }, false)
                return {
                    text: completedNow ? 'Загрузка завершена' : 'Обновление не требуется',
                    color: completedNow ? 'green--text text--darken-4' : 'light-blue--text text--darken-4'
                }
            case 'interrupted':
                return {
                    text: this.$store.getters.networkState === 'offline' ? 'Нет соединения с интернетом' : this.error,
                    color: 'red--text text--accent-4'
                }
            case 'paused':
                return {
                    text: 'Загрузка приостановлена',
                    color: 'yellow--text text--darken-4'
                }
            default:
                return {
                    text: this.needUpdate ? 'Готов к загрузке' : 'Обновление не требуется',
                    color: 'light-blue--text text--darken-4'
                }
        }
    }
    calcProgress(page: number, total: number) {
        return Math.trunc(page / total * 100)
    }
    registerWorker() {
        worker = new Worker();
        worker.addEventListener('message', this.onWorkerMessage)
        this.status = 'installed'
    }
    start() {
        this.isDownloadAll = false
        if (!worker) this.registerWorker();
        worker!.postMessage({
            action: 'start',
            requests: this.tasks.filter((task) => task.needUpdate),
        });
        this.status = 'downloading'
    }
    startAll() {
        this.isDownloadAll = true
        if (!worker) this.registerWorker();
        worker!.postMessage({
            action: 'start',
            requests: this.tasks,
        });
        this.status = 'downloading'
    }
    private onWorkerMessage(event: MessageEvent) {
        if (!event.data.done && event.data.value.error) {
            this.status = 'interrupted';
            this.error = event.data.value.error
            storageObservable.emit('downloadGlobalState', this.stateSnapshot(), false)
        } else if (!event.data.done && this.status !== 'paused' && this.status !== 'installed') {
            (event.data.value as Array<{
                name: string,
                page: number,
                total: number
            }>).forEach((task) => {
                let ind = this.tasks.findIndex((t) => t.viewName === task.name)
                this.tasks[ind].page = task.page
                this.tasks[ind].total = task.total
                if (task.page === task.total) this.tasks[ind].needUpdate = false
            });
            storageObservable.emit('downloadGlobalState', this.stateSnapshot(), false)
            this.next()
        }
        else if (event.data.done) {
            this.status = 'completed'
            storageObservable.emit('downloadGlobalState', this.stateSnapshot(), false)
        }
    }
    next() {
        this.error = '';
        this.msg = ''
        this.status = 'downloading'
        if (!worker) {
            if (this.isDownloadAll) this.startAll()
            else this.start()
            return;
        } else
            worker.postMessage({
                action: 'next',
            })
    }
    pause() {
        this.status = 'paused'
        storageObservable.emit('downloadGlobalState', this.stateSnapshot(), false)
    }
    reset() {
        this.status = 'installed'
        this.state.page = 0;
        this.state.total = 1;
        this.tasks.forEach((task) => {
            task.page = 0;
            task.total = 1;
            task.needUpdate = true;
        })
        storageObservable.emit('downloadGlobalState', this.stateSnapshot(), false)
    }
    getTaskStatus(ind: number) {
        switch (this.status) {
            case 'downloading':
                return this.tasks[ind].page === 0 ?
                    (!this.isDownloadAll && !this.tasks[ind].needUpdate ? 'Не требует обновление' : 'В очереди') :
                    (this.tasks[ind].page === this.tasks[ind].total ? 'Готово' : 'В процессе')
            case 'paused':
                return this.tasks[ind].page === 0 ?
                    !this.isDownloadAll && !this.tasks[ind].needUpdate ? 'Не требует обновление' : 'В очереди' :
                    this.tasks[ind].page === this.tasks[ind].total ? 'Готово' : 'Пауза'
            case 'interrupted':
                return this.tasks[ind].page === 0 ?
                    !this.isDownloadAll && !this.tasks[ind].needUpdate ? 'Не требует обновление' : 'В очереди' :
                    this.tasks[ind].page === this.tasks[ind].total ? 'Готово' : 'Ошибка'
            case 'completed':
                return this.tasks[ind].page === 0 && !this.tasks[ind].needUpdate ? 'Не требует обновление' : 'Готово';
            default:
                return this.tasks[ind].needUpdate ? 'Требуется обновление' : 'Не требует обновление'
        }

    }
    stateSnapshot() {
        return {
            status: this.status,
            error: this.error,
            msg: this.msg,
            lastUpdate: +new Date(),
            region: this.$store.getters.profileRegion,
            user: this.$store.getters.profile.email,
            isDownloadAll: this.isDownloadAll,
            tasks: this.tasks,
        } as DownloadGlobalState
    }
    storageSubscribe() {
        storageObservable.subscribe('downloadGlobalState', (downloadState: DownloadGlobalState) => {
            this.status = downloadState.status
            this.error = downloadState.error
            this.msg = downloadState.msg
            this.isDownloadAll = downloadState.isDownloadAll
            this.tasks = downloadState.tasks

            if (this.status === 'downloading' && worker) {
                worker.terminate()
                worker = null
            }
        })
    }
    managerStatusSubscribe() {
        storageObservable.subscribe('getManagerStatus', () => {
            storageObservable.emit('managerStatus', !(this.status === 'downloading' && worker))
        })
    }
    async verifyStart() {
        try {
            let count = await this.$fetch(REQ_URL.WINDOW_COUNT)
            storageObservable.emit('getManagerStatus', true)
            let needStart = await new Promise((res) => {
                let i = 0, needStart = true
                if (count)
                    storageObservable.subscribe('managerStatus', (data: boolean) => {
                        i++;
                        needStart = needStart && data
                        if (count === i) res(needStart)
                    })
                else res(needStart)
            })
            if (needStart) this.start()
        } catch (error) {

        }
    }
    created() {
        let autoDownload = false
        if (localStorage && localStorage.getItem('autoDownload')) {
            let autoDownloadState = (JSON.parse(localStorage.getItem('autoDownload') as string) as { status: boolean, user: string }[]).find((state) => state.user === this.$store.getters.profile.email)
            if (autoDownloadState) autoDownload = autoDownloadState.status
        }
        this.autoDownload = autoDownload
    }
    mounted() {
        this.storageSubscribe()

        /// вычисляем текущее состояние
        let downloadState!: DownloadGlobalState;
        let needUpdate = false;
        if (localStorage.getItem('downloadGlobalState')) {
            downloadState = JSON.parse(localStorage.getItem('downloadGlobalState') as string);
            if (downloadState.region !== this.$store.getters.profileRegion ||
                (+new Date() - downloadState.lastUpdate) / 1000 / 60 / 60 > 12) needUpdate = true
            else {
                this.tasks = downloadState.tasks
                this.status = downloadState.status
                this.error = downloadState.error
                this.msg = downloadState.msg
                this.isDownloadAll = downloadState.isDownloadAll
                if (!this.isDownloadAll && this.status !== 'downloading' && this.status !=='interrupted' && this.status !== 'paused' ) this.tasks.forEach((task) => {
                    if (!task.needUpdate) task.page = 0
                })
            }

        } else needUpdate = true

        // если состояние отсутвует или просрочено, то создаем чистые таски.
        if (!this.tasks.length) {
            if (this.$store.getters.profileType === 'manager') {
                this.tasks.push({
                    url: REQ_URL.IMPORT_CLIENTS,
                    type: 'clients',
                    page: 0,
                    total: 1,
                    viewName: 'Клиенты',
                    needUpdate: needUpdate || (downloadState && downloadState.user) !== this.$store.getters.profile.email
                })
            }

            this.tasks.push({
                url: REQ_URL.IMPORT_PRODUCTS,
                type: 'products',
                page: 0,
                total: 1,
                viewName: 'Продукты',
                needUpdate: needUpdate
            })
        }

        this.managerStatusSubscribe()
        //если включено автоскачивание или статус 'downloading', то пытаемся начать его с некоторой задержкой
        if (this.status === 'downloading' || this.autoDownload) this.verifyStart()
    }
}